import React, { useMemo } from 'react';
import { map } from 'lodash';
import { DOMAIN_ORGANIZATION, DOMAIN_ORGANIZATION_LOWER, DOMAIN_SEASON, DOMAIN_SEASON_LOWER } from '../../constants/domainCopy';

import { CopyTextField } from '../../components/inputs';
import { useLeagueConfiguration } from '../../hooks/store';

const OrganizationInviteUrl = () => {
    
    const leagueConfiguration = useLeagueConfiguration();

    const createOrganizationUrls = useMemo(() => {
        if (!leagueConfiguration) return [];
        return map(leagueConfiguration.inviteCodes, (code: string) => {
            return `${leagueConfiguration.domain}/organizations/create/${code}`;
        });
    }, [leagueConfiguration]);

    return (
        <section className="settings-page__invite-url global-container-centered">
            <p className="text-center">
                Sending this link to {DOMAIN_ORGANIZATION_LOWER} managers will allow them to create their{' '}
                {DOMAIN_ORGANIZATION_LOWER} in this league.
            </p>
            {createOrganizationUrls.map((url: string) => (
                <CopyTextField id="organizationInviteLink" label="Invite Link" value={url} />
            ))}
        </section>
    );
};

export default OrganizationInviteUrl;
